import { useState } from "react";
import { useDispatch } from "react-redux";
import { toggleModal } from '../../../../reducers/modalReducer';
import { postRequest, showMessage } from '../../../../config';
import ModuleForm from "../ModuleForm";

const ModuleCreate = ({ onSuccess, onCancel }) => {
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFormChange = (formData) => {
        // Form data changes are handled internally by ModuleForm
        // This can be used for additional validation or side effects if needed
    };

    const handleSubmit = async (formData) => {
        setIsSubmitting(true);
        try {
            // Use the new temp-modules create endpoint
            // This endpoint creates module, sections, and questions in one transaction
            const response = await postRequest('/modules/temp-modules', formData);

            if (response?.code === 200) {
                const result = response.body || response;
                showMessage(response.message || 'Module created successfully!');

                // Log creation summary
                console.log(`Created: ${result.sectionsCreated || 0} sections, ${result.questionsCreated || 0} questions`);

                if (onSuccess) {
                    onSuccess(result);
                }
                if (onCancel) {
                    onCancel();
                }
            } else {
                showMessage(response.message || 'Failed to create module');
            }
        } catch (error) {
            console.error('Error creating module:', error);
            showMessage('Failed to create module. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        } else {
            // Default behavior: navigate back or close modal
            window.history.back();
        }
    };

    return (
        <div className="modules-container" style={{ padding: '2rem' }}>
            <ModuleForm
                moduleData={null}
                onFormChange={handleFormChange}
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isEdit={false}
            />
        </div>
    );
};

export default ModuleCreate;
